// DEV NOTE: Classification threshold per Avanza UC 2026 bases:
//   Cat. A — Emergente: doctorate from January 2020 onwards ("desde el 2020 en adelante")
//   Cat. B — Consolidado: doctorate before January 2020 ("antes de enero 2020")
// The threshold is defined at month precision, not just year.
// Production: read from Contest.config.classificationThreshold: { year: number; month: number }
// (month is 1-indexed: 1 = January … 12 = December).
// Consolidado = doctorateDate strictly before threshold date.
export const CLASSIFICATION_THRESHOLD = { year: 2020, month: 1 } as const;

export function isConsolidated(
  doctorateYear: number | undefined | null,
  doctorateMonth: number | undefined | null
): boolean {
  if (!doctorateYear) return false;
  const { year: ty, month: tm } = CLASSIFICATION_THRESHOLD;
  const m = doctorateMonth ?? 6; // assume June when month not captured
  return doctorateYear < ty || (doctorateYear === ty && m < tm);
}
